export default function ApproachSection() {
  return (
    <section className="relative w-full py-28 md:py-36 px-6 md:px-10 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12">
          <div className="section-divider mb-8"></div>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-foreground-950 mb-8">
            How We Work
          </h2>
        </div>

        <div className="space-y-8 mb-20">
          <p className="text-base md:text-lg leading-relaxed text-foreground-700 font-light max-w-3xl">
            The team follows modern software engineering practices, including clean architecture, performance optimization, and user-centered design. These principles guide every decision, from initial system design through to ongoing maintenance and iteration.
          </p>
        </div>

        <div className="space-y-16">
          <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start">
            <div className="md:w-1/3">
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 mb-4">
                <i className="ri-layout-masonry-line text-xl text-accent-700"></i>
              </div>
              <h3 className="font-heading text-xl font-medium text-foreground-950">
                Clean Architecture
              </h3>
            </div>
            <div className="md:w-2/3">
              <p className="text-base leading-relaxed text-foreground-600 font-light">
                We structure every system with clear separation of concerns, well-defined boundaries, and modular components. This approach ensures that code remains understandable, testable, and adaptable as requirements evolve over time.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start">
            <div className="md:w-1/3">
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 mb-4">
                <i className="ri-speed-up-line text-xl text-secondary-700"></i>
              </div>
              <h3 className="font-heading text-xl font-medium text-foreground-950">
                Performance Optimization
              </h3>
            </div>
            <div className="md:w-2/3">
              <p className="text-base leading-relaxed text-foreground-600 font-light">
                Every system we build is optimized for responsiveness and efficiency. Through careful profiling, resource management, and architectural decisions, we ensure that performance is not an afterthought but a foundational characteristic of the final product.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start">
            <div className="md:w-1/3">
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-100 mb-4">
                <i className="ri-user-heart-line text-xl text-accent-700"></i>
              </div>
              <h3 className="font-heading text-xl font-medium text-foreground-950">
                User-Centered Design
              </h3>
            </div>
            <div className="md:w-2/3">
              <p className="text-base leading-relaxed text-foreground-600 font-light">
                Design decisions are driven by a deep understanding of user needs and behaviors. We prioritize intuitive interfaces, seamless interactions, and accessible experiences that make technology feel natural and effortless.
              </p>
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start">
            <div className="md:w-1/3">
              <div className="w-10 h-10 flex items-center justify-center rounded-md bg-secondary-100 mb-4">
                <i className="ri-loop-left-line text-xl text-secondary-700"></i>
              </div>
              <h3 className="font-heading text-xl font-medium text-foreground-950">
                Continuous Innovation
              </h3>
            </div>
            <div className="md:w-2/3">
              <p className="text-base leading-relaxed text-foreground-600 font-light">
                We actively explore new technologies and evolve internal processes to maintain high technical excellence. By continuously improving development workflows and adopting up-to-date engineering standards, we deliver reliable and future-ready IT solutions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}